export default __webpack_public_path__ + "static/media/icon--minus.5de4ebb1.svg";